<template>
	<div>

		<el-row :gutter="20" style="border: 1px solid #e2e7ed">
			<el-col v-if="!onlyRead">
				<div style="padding: 10px">
					<div style="float: right;width: 50%;text-align: right">
						<upload-document buttonName="Agregar Documento"  @fileInfo="addFileToRequest"/>
					</div>
				</div>
			</el-col>
			<el-col>
				<slot name="main">

				</slot>




				<el-table :data="item.documents"
						  size="small" style="width: 100%">
					<el-table-column
							label="Nombre de archivo"
							min-width="200px">
						<template slot-scope="scope">
							{{scope.row.fileName ? scope.row.fileName : ''}}
							<span v-if="scope.row.file">
                              {{  scope.row.file.fileName}}
                         </span>
						</template>
					</el-table-column>

					<el-table-column
					label="Descripción"
					min-width="200px">
					<template slot-scope="scope">

						<el-input v-model="scope.row.description"
						          :disabled="onlyRead== true ? true: false"
						          placeholder="">
						</el-input>

					</template>
					</el-table-column>


					<el-table-column label="Opciones de edición" align="center" min-width="160">
						<template slot-scope="scope">
							<div>
								<el-button-group>
									<el-tooltip
											v-if="scope.row.file_id"
											class="item"
											effect="dark"
											content="Ver documento"
											placement="top-end">
										<el-button
												size="small"
												icon="el-icon-view"
												@click="showPdf(scope.row.file_id)">
										</el-button>
									</el-tooltip>
									<el-tooltip
											class="item"
											effect="dark"
											content="Eliminar documento"
											placement="top-end">
										<el-button
												:disabled="onlyRead== true ? true: false"
												size="small"
												type="danger"
												@click="removeDocument(scope.row)">
											<i class="fas fa-trash"></i>
										</el-button>
									</el-tooltip>
								</el-button-group>
							</div>
						</template>

					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<ShowDocuments :closeShowDocument="closeShowDocument"
		               :activeShowDocument="activeShowDocument"
		               :fileNameHash="fileNameHash"
		               v-if="activeShowDocument"/>
	</div>
</template>
<script>
	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
	import UploadDocument from '@/utils/UploadDocument';
	import ShowDocuments from '@/utils/ShowDocuments';
	export default {

		components: {
			UploadDocument,
			ShowDocuments
		},
		props: {
			item: {
			    type: Object,
				required: true
			},
            key2: {

            }
		},
		data() {
			return {
				fileData:{},
				fileNameHash: null,
				activeShowDocument : false
			}
		},
		computed: {
			...mapGetters('form', {
				catalogs: 'catalogs',
				requestForm: "requestForm",
				onlyRead: "onlyRead",
                providersDocumentsAlias: "providersDocumentsAlias"
			}),
		},
		methods: {
			...mapMutations('form', {
				addDocToProvider:"addDocToProvider",
				removeDocumentToProvider:"removeDocumentToProvider"
			}),
			showPdf(id){


				let  _self = this;
				let url = '/api/get-hash-file/'+id;

				var xhr = new XMLHttpRequest();
				xhr.open('PUT', url , false);
				xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				xhr.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('acquisition_token') );

				xhr.onreadystatechange=function() {
					if (xhr.readyState === 4){
						if(xhr.status === 200){
							var data = JSON.parse(xhr.responseText);
							_self.fileNameHash = data.fileNameHash;
							_self.activeShowDocument =true;
						} else {
							console.log("error");
						}
					}
				}
				xhr.send();

			},
			closeShowDocument(){
				this.activeShowDocument = false;
			},
			removeDocument(item) {

				this.$confirm('¿Desea eliminar este documento?').then(confirm => {
					this.removeDocumentToProvider(
						{
							item:this.item,
							payload:  item
						});
				}).catch(e => {

				});

			},
			addFileToRequest(fileInfo){
				let payload = {
					file_id: fileInfo.id,
					fileName: fileInfo.fileName,
					provider_id: this.item.id
				};
				this.addDocToProvider({
					item: this.item,
                    index: this.key2,
					payload:  payload
				});


			},

		}
	};

</script>

